var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckboxTextarea = function SvgCheckboxTextarea(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 16,
    viewBox: "0 0 40 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox-textarea",
    transform: "translate(-56 -241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11324",
    "data-name": "Group 11324",
    transform: "translate(-44 -873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11276",
    "data-name": "Group 11276",
    transform: "translate(124 1114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    "data-name": "Path 3961",
    d: "M17.222,4.778V17.222H4.778V4.778H17.222m0-1.778H4.778A1.783,1.783,0,0,0,3,4.778V17.222A1.783,1.783,0,0,0,4.778,19H17.222A1.783,1.783,0,0,0,19,17.222V4.778A1.783,1.783,0,0,0,17.222,3Z",
    transform: "translate(-3 -3)",
    fill: "#3c3e69"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3961-2",
    "data-name": "Path 3961",
    d: "M12.6,15H7V13.4h5.6ZM15,11.8H7V10.2h8Zm0-3.2H7V7h8Z",
    transform: "translate(121 1111)",
    fill: "#3c3e69"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check-solid",
    d: "M4.755,75.333l-4.55-4.55a.7.7,0,0,1,0-.99l.99-.99a.7.7,0,0,1,.99,0L5.25,71.868,11.815,65.3a.7.7,0,0,1,.99,0l.99.99a.7.7,0,0,1,0,.99l-8.05,8.05a.7.7,0,0,1-.99,0Z",
    transform: "translate(56 178.901)",
    fill: "#3c3e69"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckboxTextarea, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkbox-textarea.a2edb4e0.svg";
export { ForwardRef as ReactComponent };